export enum ProfileType {
  Preserver = 1,
  Sponsor = 2,
  Admin = 3,
  SuperAdmin = 4,
  Agent = 5,
  Supervisor = 6,
}
